import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: `${theme.spacing(5)}px ${theme.spacing(5)}px`,
    backgroundColor: '#FCF9F8',
    height: '100%'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  }
}))
